module.exports = __webpack_public_path__ + "static/media/step4.caf7dbb8.png";